export default __webpack_public_path__ + "static/media/b_slide4.28ee3f68.jpg";